"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Applicants_1 = require("./Applicants");
exports.default = Applicants_1.Applicants;
